module.exports = __webpack_public_path__ + "static/media/6.5-inch Screenshot 4.b95fc83f.jpeg";